import {
    VmcStatusDto as VmcStatus,
    ApiError,
    OpenAPI,
    VmcsService,
} from '../openapi';
import { ApiResult } from '../openapi/core/ApiResult';
import { PropertyInfo } from '../openapi/models/PropertyInfo';

const { get, get1, get1ByVmcId, getTotalCount, getOnlineCount, put, propertyInfo } = VmcsService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getVmcs = async (token: string, range: string, filter?: Record<string, string>, search?: Record<string, string>) => {
    const vmcs: ApiResult = await get(token, range, filter, search);
    return vmcs;
};

export const getVmcCount = async (token: string, filter?: Record<string, string>, search?: Record<string, string>): Promise<string> => {
    const result: string = await getTotalCount(token, filter, search);
    const count = result.split('/')[1];
    return count;
};

export const getOnlineVmcsCount = async (token: string): Promise<string> => {
    const result: string = await getOnlineCount(token);
    const count = result.split('/')[1];
    return count;
};

export const getVmcById = async (token: string, id: number): Promise<VmcStatus> => {
    return await get1(token, id);
};

export const getVmcByVmcId = async (token: string, vmcId: string, language: string): Promise<VmcStatus> => {
    return await get1ByVmcId(token, vmcId, language);
};


export const updateVmc = async (
    token: string,
    id: number,
    vmc: VmcStatus
): Promise<VmcStatus> => {
    const v = { ...vmc };
    v.propertyNames = {};
    return await put(token, id, v);
};

export const addVmc = async (token: string, newVmc: VmcStatus): Promise<number> => {
    const url = `${OpenAPI.BASE}/api/Vmcs`;
    const resp = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newVmc)
    });

    if (!resp.ok) {
        // Throw an ApiError like the generated client does, so callers can read the validation errors from body
        const txt = await resp.text();
        throw new ApiError({ url: resp.url, ok: resp.ok, status: resp.status, statusText: resp.statusText, body: txt, header: null }, txt || `HTTP ${resp.status}`);
    }

    // API returns the created id as JSON number
    const id = await resp.json();
    return id;
};

export const getPropertyInfo = async (token: string): Promise<Record<string, PropertyInfo>> => {
    return await propertyInfo(token);
};